import _sfc_main from "./AudioIcon.vue2.mjs";
/* empty css                */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: ["audio-icon-container", `${_vm.size == "small" && "small"}`] }, [_c("div", { staticClass: "audio-level-container" }, [_c("div", { staticClass: "audio-level", style: _setup.audioLevelStyle })]), _c(_setup.SvgIcon, { staticClass: "audio-icon", attrs: { "icon": _setup.icon } })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "6e9fcb9f"
);
const AudioIcon = __component__.exports;
export {
  AudioIcon as default
};
